import Axios from 'axios';

// Matches wrench-www's Services/ContactData.ts NEXT_PUBLIC_API_URL fallback
// pattern — wrench-api's own dev port, for local dev without any
// docker-compose env var. Dockerfile.prod bakes this as a
// https://api.wrenchboard.com sentinel instead (see docker-entrypoint.sh),
// replaced with the real per-environment API host at container start.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:21000';

async function JobsData(limit = 30) {
    let response = await Axios.get(`${API_BASE_URL}/website/job-offers/public`, {
        params: { limit },
    });
    // Defensive: a misconfigured API_BASE_URL (e.g. the runtime sentinel
    // never got replaced) sends this at a relative path, which `serve -s`
    // silently answers with index.html (200, but not JSON) instead of a
    // real error — response.data.offers would then be undefined, and
    // RecentJobsOne's jobs.length crashes the whole page with no Error
    // Boundary in this app. Always return an array.
    return Array.isArray(response.data?.offers) ? response.data.offers : [];
}

export default JobsData;
